<template>
  <div>
    <LoadingSpinner :loading="loading" :text="loadingSpinnerText" />
    <b-row align-v="center" v-if="!loading">
      <b-col cols="12" md="12">
        <TagComponent
          category_name="tag_person"
          :multiple="true"
          :requiredLabel="tagInputRequired"
          :parentPermissions="permissions"
          :checkValidation="checkTagSelected"
          :parentValue="tags"
          @updateCheckValidation="updateCheckTagSelected"
          @getSelected="getSelected"
        />
      </b-col>
      <b-col cols="12" md="12" class="text-right">
        <b-button v-if="isAdmin(permissions)" variant="success" @click="save">
          {{ $lang.submitButton }}
          <i class="fa fa-check" />
        </b-button>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import LoadingSpinner from "@/components/base/LoadingSpinner";
import TagComponent from "@/components/tag/tagComponent.vue";
import { generateApiUrl, isAdmin } from "@/shared/utils";
import { pathOr } from "ramda";
import { required } from "vuelidate/lib/validators";
import { mapActions } from "vuex";

export default {
  name: "person-tags",
  components: { LoadingSpinner, TagComponent },
  validations: {
    tag_selected: { required },
  },
  props: {
    code: {
      type: [String, Number],
      default: null,
    },
    parentPermissions: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      loading: false,
      loadingSpinnerText: this.$lang.receiving_data,
      permissions: [],
      tags: [],
      checkTagSelected: false,
      tagInputRequired: false,
    };
  },
  created() {
    this.fetchData();
  },
  methods: {
    ...mapActions(["putTags"]),
    generateApiUrl,
    isAdmin,
    pathOr,
    updateCheckTagSelected(data) {
      this.checkTagSelected = data;
    },
    getSelected(data) {
      this.tags = data;
    },
    async save() {
      this.checkTagSelected = true;
      if (this.tagInputRequired && !this.tags.length) return;

      try {
        this.loading = true;
        this.loadingText = this.$lang.sending_data;
        const payload = {
          resource: "person",
          key: this.code,
          tag_id: this.tags.map((tag) => tag.value),
        };
        await this.putTags(payload);
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.loading = false;
      }
    },
    async fetchData() {
      try {
        this.loading = true;
        this.loadingSpinnerText = this.$lang.receiving_data;
        const url = generateApiUrl(["profile", "person_tags"], [this.code]);
        const response = await this.$httpService.get(url);
        this.tags = pathOr([], ["data", "data"], response).map((x) => {
          return {
            text: pathOr(null, ["caption"], x),
            value: pathOr(null, ["id"], x),
          };
        });
        this.permissions = pathOr([], ["data", "permissions"], response);
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
